// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1rqUB","colMin":"styles_colMin__2oQGU","colCheckbox":"styles_colCheckbox__2E-rN"};